function isExpired(expires: string) {
  const expirationDate = new Date(expires);
  const now = new Date();
  return now.getTime() - expirationDate.getTime() >= 0;
}
const NODE_ENV = process.env.REACT_APP_ENV || 'test';

function getKey(key: string) {
  return `${key}_h5_${NODE_ENV}`;
}

// eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
const _memory: { [key: string]: any } = {};
class Storage {
  static get memory(): typeof _memory {
    return _memory;
  }

  static getItem<T>(key: string): T | null {
    const storageVal = localStorage.getItem(getKey(key));
    if (storageVal) {
      const data = JSON.parse(storageVal);
      if (data.expires && isExpired(data.expires)) {
        this.removeItem(key);
        return null;
      }
      return data.val;
    }
    return null;
  }

  static setItem<T>(key: string, val: T, expirationDate?: Date): void {
    if (val !== undefined) {
      const data = {
        expires: expirationDate?.toUTCString(),
        val,
      };
      localStorage.setItem(getKey(key), JSON.stringify(data));
    } else {
      // eslint-disable-next-line no-console
      console.warn(
        `一个预期之外的错误，你设置了${key}的值为: ${val}，此次操作未生效`,
      );
    }
  }

  static clear(): void {
    return localStorage.clear();
  }

  static removeItem(key: string): void {
    return localStorage.removeItem(getKey(key));
  }
}

export default Storage;
